import { axiosClient } from "./axiosClient";

export interface CategoryFormData {
  name: string;
  slug?: string;
  icon?: string;
  description?: string;
  parentCategory?: string;
  isActive?: boolean;
  order?: number;
  metadata?: {
    allowsRealEstate?: boolean;
    allowsVehicles?: boolean;
    allowsExchange?: boolean;
    requiresAdditionalFields?: string[];
  };
}

// Fetch all categories (tree structure)
export const fetchCategories = async () => {
  const { data } = await axiosClient.get('/marketplace/categories/tree');
  return data;
};

// Fetch all categories including inactive (for admin)
export const fetchAllCategories = async () => {
  const { data } = await axiosClient.get('/marketplace/categories?includeInactive=true');
  return data;
};

// Create new category (admin only)
export const createCategory = async (categoryData: CategoryFormData) => {
  const { data } = await axiosClient.post('/marketplace/categories', categoryData);
  return data;
};

// Update category (admin only)
export const updateCategory = async (categoryId: string, categoryData: Partial<CategoryFormData>) => {
  const { data } = await axiosClient.put(`/marketplace/categories/${categoryId}`, categoryData);
  return data;
};

// Delete category (admin only)
export const deleteCategory = async (categoryId: string) => {
  const { data } = await axiosClient.delete(`/marketplace/categories/${categoryId}`);
  return data;
};

// Toggle category active status (admin only) - uses update endpoint
export const toggleCategoryStatus = async (categoryId: string, isActive: boolean) => {
  const { data } = await axiosClient.put(`/marketplace/categories/${categoryId}`, {
    isActive,
  });
  return data;
};
